import type { Action } from 'redux';

export interface ApplicationFlagEntry {
  applicationId: number;
  hasDismissedReductionMigrationModal: boolean;
}

export interface ApplicationFlagsState {
  applications: Array<ApplicationFlagEntry>;
}

interface CreateApplicationFulfilledAction extends Action {
  type: 'CREATE_APPLICATION_FULFILLED';
  application: { id: number };
}

interface SetHasDismissedReductionMigrationModalAction extends Action {
  type: 'SET_HAS_DISMISSED_REDUCTION_MIGRATION_MODAL';
  applicationId: number;
}

type ApplicationFlagsAction = CreateApplicationFulfilledAction | SetHasDismissedReductionMigrationModalAction;

const defaultFlags: Omit<ApplicationFlagEntry, 'applicationId'> = {
  hasDismissedReductionMigrationModal: false,
};

const defaultState: ApplicationFlagsState = {
  applications: [],
};

function reducer(state: ApplicationFlagsState = defaultState, action: ApplicationFlagsAction): ApplicationFlagsState {
  switch (action.type) {
    case 'CREATE_APPLICATION_FULFILLED': {
      return {
        ...state,
        applications: [...state.applications, { applicationId: action.application.id, ...defaultFlags }],
      };
    }
    case 'SET_HAS_DISMISSED_REDUCTION_MIGRATION_MODAL': {
      const applications = state.applications || [];
      if (!applications.some((applicationFlags) => applicationFlags.applicationId === action.applicationId)) {
        return {
          ...state,
          applications: [
            ...applications,
            { applicationId: action.applicationId, ...defaultFlags, hasDismissedReductionMigrationModal: true },
          ],
        };
      }
      return {
        ...state,
        applications: applications.map((applicationFlags) => {
          if (applicationFlags.applicationId === action.applicationId) {
            return {
              ...applicationFlags,
              hasDismissedReductionMigrationModal: true,
            };
          }
          return applicationFlags;
        }),
      };
    }
    default:
      return state;
  }
}

export default reducer;
